import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export default function NewContributionsSkeleton() {
  return (
    <Card className="w-full bg-white">
      {/* Header */}
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between gap-4">
          <Skeleton className="h-7 w-[520px] rounded-md" />
          <div className="flex items-center gap-2">
            <Skeleton className="h-10 w-24 rounded-md" />
            <Skeleton className="h-10 w-10 rounded-md" />
          </div>
        </div>
      </CardHeader>

      <CardContent className="space-y-6">
        {/* Section title */}
        <Skeleton className="h-6 w-52 rounded-md" />

        {/* Three rows of pills */}
        <div className="mt-3 space-y-4">
          {[0, 1, 2].map((row) => (
            <div
              key={row}
              className="grid grid-cols-[220px_1fr] items-center gap-4"
            >
              <Skeleton className="h-6 w-40 rounded-md" />
              <div className="flex flex-wrap gap-4">
                {Array.from({ length: 12 }).map((_, i) => (
                  <Skeleton key={i} className="h-12 w-20 rounded-xl" />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Table */}
        <div className="rounded-xl border p-3">
          {/* Header row */}
          <div className="grid grid-cols-5 gap-4 border-b pb-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton key={i} className="h-5 w-40 rounded-md" />
            ))}
          </div>
          {/* Body row */}
          <div className="grid grid-cols-5 gap-4 pt-3">
            <Skeleton className="h-6 w-28 rounded-md" />
            <Skeleton className="h-6 w-28 rounded-md" />
            <Skeleton className="h-6 w-[280px] rounded-md" />
            <div className="flex flex-col gap-2">
              <Skeleton className="h-6 w-24 rounded-md" />
              <Skeleton className="h-6 w-24 rounded-md" />
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-6 w-24 rounded-md" />
              <Skeleton className="h-6 w-28 rounded-md" />
              <Skeleton className="h-6 w-6 rounded-md" />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
